export const UPDATE_CODE = 'UPDATE_CODE';
export const UPDATE_OUTPUT_FILE_NAME = 'UPDATE_OUTPUT_FILE_NAME';

export const OBFUSCATE = 'OBFUSCATE';
export const OBFUSCATE_PENDING = 'OBFUSCATE_PENDING';
export const OBFUSCATE_FULFILLED = 'OBFUSCATE_FULFILLED';
export const OBFUSCATE_REJECTED = 'OBFUSCATE_REJECTED';

export const RESET_OPTIONS = 'RESET_OPTIONS';

export const SET_OPTIONS_PRESET = 'SET_OPTIONS_PRESET';

export const TOGGLE_COMPACT_CODE = 'TOGGLE_COMPACT_CODE';
export const TOGGLE_SIMPLIFY = 'TOGGLE_SIMPLIFY';

export const TOGGLE_SELF_DEFENDING = 'TOGGLE_SELF_DEFENDING';
export const TOGGLE_DISABLE_CONSOLE_OUTPUT = 'TOGGLE_DISABLE_CONSOLE_OUTPUT';

export const TOGGLE_DEBUG_PROTECTION = 'TOGGLE_DEBUG_PROTECTION';
export const TOGGLE_DEBUG_PROTECTION_INTERVAL = 'TOGGLE_DEBUG_PROTECTION_INTERVAL';

export const TOGGLE_SOURCEMAP = 'TOGGLE_SOURCEMAP';
export const SET_SOURCEMAP_MODE = 'SET_SOURCEMAP_MODE';
export const SET_SOURCEMAP_BASE_URL = 'SET_SOURCEMAP_BASE_URL';
export const SET_SOURCEMAP_FILE_NAME = 'SET_SOURCEMAP_FILE_NAME';

export const TOGGLE_SPLIT_STRINGS = 'TOGGLE_SPLIT_STRINGS';
export const SET_SPLIT_STRINGS_CHUNK_LENGTH = 'SET_SPLIT_STRINGS_CHUNK_LENGTH';

export const SET_STRING_ARRAY_THRESHOLD = 'SET_STRING_ARRAY_THRESHOLD';
export const SET_STRING_ARRAY_INDEXES_TYPE = 'SET_STRING_ARRAY_INDEXES_TYPE';
export const TOGGLE_STRING_ARRAY = 'TOGGLE_STRING_ARRAY';
export const TOGGLE_STRING_ARRAY_INDEX_SHIFT = 'TOGGLE_STRING_ARRAY_INDEX_SHIFT';
export const TOGGLE_STRING_ARRAY_ROTATE = 'TOGGLE_STRING_ARRAY_ROTATE';
export const TOGGLE_STRING_ARRAY_SHUFFLE = 'TOGGLE_STRING_ARRAY_SHUFFLE';
export const SET_STRING_ARRAY_ENCODING = 'SET_STRING_ARRAY_ENCODING';

export const TOGGLE_STRING_ARRAY_CALLS_TRANSFORM = 'TOGGLE_STRING_ARRAY_CALLS_TRANSFORM';
export const SET_STRING_ARRAY_CALLS_TRANSFORM_THRESHOLD = 'SET_STRING_ARRAY_CALLS_TRANSFORM_THRESHOLD';

export const SET_STRING_ARRAY_WRAPPERS_COUNT = 'SET_STRING_ARRAY_WRAPPERS_COUNT';
export const SET_STRING_ARRAY_WRAPPERS_PARAMETERS_MAX_COUNT = 'SET_STRING_ARRAY_WRAPPERS_PARAMETERS_MAX_COUNT';
export const TOGGLE_STRING_ARRAY_WRAPPERS_CHAINED_CALLS = 'TOGGLE_STRING_ARRAY_WRAPPERS_CHAINED_CALLS';
export const SET_STRING_ARRAY_WRAPPERS_TYPE = 'SET_STRING_ARRAY_WRAPPERS_TYPE';

export const ADD_DOMAIN_LOCK = 'ADD_DOMAIN_LOCK';
export const REMOVE_DOMAIN_LOCK = 'REMOVE_DOMAIN_LOCK';
export const SET_DOMAIN_LOCK_REDIRECT_URL = 'SET_DOMAIN_LOCK_REDIRECT_URL';

export const ADD_RESERVED_NAME = 'ADD_RESERVED_NAME';
export const REMOVE_RESERVED_NAME = 'REMOVE_RESERVED_NAME';

export const ADD_FORCE_TRANSFORM_STRING = 'ADD_FORCE_TRANSFORM_STRING';
export const REMOVE_FORCE_TRANSFORM_STRING = 'REMOVE_FORCE_TRANSFORM_STRING';

export const ADD_RESERVED_STRING = 'ADD_RESERVED_STRING';
export const REMOVE_RESERVED_STRING = 'REMOVE_RESERVED_STRING';

export const ADD_DICTIONARY_IDENTIFIER = 'ADD_DICTIONARY_IDENTIFIER';
export const REMOVE_DICTIONARY_IDENTIFIER = 'REMOVE_DICTIONARY_IDENTIFIER';

export const SET_SEED = 'SET_SEED';

export const SET_CONTROL_FLOW_FLATTENING_THRESHOLD = 'SET_CONTROL_FLOW_FLATTENING_THRESHOLD';
export const TOGGLE_CONTROL_FLOW_FLATTENING = 'TOGGLE_CONTROL_FLOW_FLATTENING';

export const SET_DEAD_CODE_INJECTION_THRESHOLD = 'SET_DEAD_CODE_INJECTION_THRESHOLD';
export const TOGGLE_DEAD_CODE_INJECTION = 'TOGGLE_DEAD_CODE_INJECTION';

export const TOGGLE_NUMBERS_TO_EXPRESSIONS = 'TOGGLE_NUMBERS_TO_EXPRESSIONS';

export const TOGGLE_UNICODE_ESCAPE_SEQUENCE = 'TOGGLE_UNICODE_ESCAPE_SEQUENCE';

export const TOGGLE_RENAME_GLOBALS = 'TOGGLE_RENAME_GLOBALS';

export const TOGGLE_RENAME_PROPERTIES = 'TOGGLE_RENAME_PROPERTIES';
export const SET_RENAME_PROPERTIES_MODE = 'SET_RENAME_PROPERTIES_MODE';

export const SET_TARGET = 'SET_TARGET';

export const SET_IDENTIFIER_NAMES_GENERATOR = 'SET_IDENTIFER_NAMES_GENERATOR';

export const SET_IDENTIFIERS_PREFIX = 'SET_IDENTIFIERS_PREFIX';

export const TOGGLE_TRANSFORM_OBJECT_KEYS = 'TOGGLE_TRANSFORM_OBJECT_KEYS';

export const TOGGLE_IGNORE_IMPORTS = 'TOGGLE_IGNORE_IMPORTS';

export const SET_DEBUG_PROTECTION_INTERVAL = 'SET_DEBUG_PROTECTION_INTERVAL';